import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
    MediaBox, MediaBoxHeader, MediaBoxBody, MediaBoxTitle, MediaBoxDescription,
    MediaBoxInfoMeta, MediaBoxInfo, Button,
} from 'react-weui'
import { WKVisible } from '../../components/wk'
import { renderMoney } from '../../utils'
import * as relaycfmAction from '../../actions/relayConfirm'


class RelayConfirmLecture extends React.Component {
    onClickPay (id) {
        this.props.relaycfmPayLecture(id)
    }
    onClickPayFree (id) {
        this.props.relaycfmPostRelayLecture(id)
    }
    handleClick() {
        const lecture = this.props.lecture
        window.location = `/lecture/${lecture.lecture.id}`
    }
    render() {
        const lecture = this.props.lecture
        if (!lecture) return null
        const benefit = this.props.getPercentFee(lecture.lecture.money, lecture.lecture.relay_percent)
        return (
            <div className='lecture-confirm'>
                <MediaBox type="appmsg" className='margin-bottom' onClick={this.handleClick.bind(this)}>
                    <MediaBoxHeader>
                        <img src={lecture.liveroom.avatar_url} alt="" />
                    </MediaBoxHeader>
                    <MediaBoxBody>
                        <MediaBoxTitle>{lecture.lecture.name}</MediaBoxTitle>
                        <MediaBoxDescription>
                            {lecture.liveroom.name || '-'}
                        </MediaBoxDescription>
                        <MediaBoxInfo>
                            <MediaBoxInfoMeta>{lecture.lecture.status === 'closed' ? '精彩回听' : '今天'}</MediaBoxInfoMeta>
                            <MediaBoxInfoMeta extra>{lecture.lecture.popular}人气</MediaBoxInfoMeta>
                        </MediaBoxInfo>
                    </MediaBoxBody>
                </MediaBox>
                <div className="pay-box text-center margin-bottom">
                    <p className="big-font">转载该课程到我的直播间</p>
                    <p className="big-font margin-bottom">{benefit > 0 ? '可获分成' : '邀请更多好友共享知识盛宴'}</p>
                     <WKVisible create={benefit > 0}>
                        <p className="margin-bottom-double text-minor text-center">
                            <span className="relay-benefit">{benefit}元</span> / 预约付费用户
                        </p>
                    </WKVisible>
                    {/*<WKVisible create={lecture.lecture.relay_fee > 0}>
                        <Button onClick={e => this.onClickPay(lecture.lecture.id)} size='normal'>
                            支付{renderMoney(lecture.lecture.relay_fee)}元转播
                        </Button>
                    </WKVisible> */}
                    {/* create={lecture.lecture.relay_fee === 0} */}
                    <WKVisible >
                        <Button onClick={e => this.onClickPayFree(lecture.lecture.id)} size='normal'>免费转载</Button>
                    </WKVisible>
                </div>
                <p className="padding text-minor">
                    1. 转载付费课程到自己直播间，有用户购买课程即可获得分成；<br />
                    2. 转载课程需要先创建自己的直播间<br />
                    3. 直播间的语音，文字，图片，PPT等都会同步到转载间，同时转载间的用户评论能同步到主直播间<br />
                    4. 转载课程不支持分销，优惠码，限时特价功能；<br />
                    5. 转载者需要购买课程，才可收听课程
                </p>
            </div>
        )
    }
}


export default connect(null, dispatch => bindActionCreators({ ...relaycfmAction }, dispatch))(RelayConfirmLecture)



// WEBPACK FOOTER //
// ./src/components/relayConfirm/RelayConfirmLecture.js